/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'

const RadioGroupContext = React.createContext({
  name: null,
  nameUniqueValue: null
})

export default RadioGroupContext
